<template>
    <v-app>
        <v-dialog v-model="dialog" max-width="400">
            <v-card>
              <v-toolbar dark>
                <v-card-title class="headline">
                  {{ `${edit ? 'Update' : 'Add'}` }}  vehicle to routes
                  <hr>
                </v-card-title>

                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-btn icon  @click="resetForm">
                    <i class="fas fa-times"></i>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
                <v-card-text>
                    <v-row>
<!--                        <v-col cols="6">-->
<!--                            <v-select-->
<!--                                    :items="routes"-->
<!--                                    item-value="id"-->
<!--                                    item-text="title"-->
<!--                                    v-model="routeVehicle.route_id" outlined dense label= "Select Route ">-->

<!--                            </v-select>-->
<!--                        </v-col>-->
                        <v-col >
                            <v-select
                                    :items="vehicles"
                                    item-value="id"
                                    item-text="title"
                                    v-model="routeVehicle.vehicle_id" outlined dense label= "Select vehicle">

                            </v-select>
                        </v-col>

                        <v-col cols="12">
                            <div class="float-right">
                                <v-btn depressed @click="dialog = false;"  class="text-gray btn btn-standard cancel-btn">Cancel</v-btn>
                                <v-btn v-if="checkIsAccessible('vehicle', 'list')" depressed :loading="isBusy" @click="createOrUpdate"  class="ml-2 text-white btn btn-primary">Save</v-btn>
                            </div>

                        </v-col>

                    </v-row>
                </v-card-text>

            </v-card>

        </v-dialog>

    </v-app>
</template>
<script>
    import {required} from "vuelidate/lib/validators";

    import StopsService from "@/core/services/Transport/StopsService";
    const stopsService = new StopsService();

    import RoutesService from "@/core/services/Transport/Routes/RoutesService";
    const routesService = new RoutesService();
    import VehiclesService from "@/core/services/Transport/Vehicles/VehiclesService";
    const vehiclesService = new VehiclesService();

    import RoutesVehicleService from "@/core/services/Transport/RoutesVehicle/RoutesVehicleService";
    const routesVehicleService = new RoutesVehicleService();
    export default {
        validations: {
            routeVehicle: {
                route_id: {required},
                vehicle_id: {required},
            }
        },
        props:['route'],

        data() {
            return {
                edit: false,
                dialog: false,
                sizeExceed: false,
                isBusy: false,
                routes: [],
                vehicles: [],
                routeVehicle: {
                    route_id: null,
                    vehicle_id: null,
                }
            };
        },
        methods: {
            showModal(id = null) {
                if (id) {
                    this.edit = true
                    this.__get(id)
                }else{
                  this.edit=false;
                  this.routeVehicle={
                        route_id: null,
                        vehicle_id: null,
                  };
                }
                if (this.route){
                    this.routeVehicle.route_id = this.route.id;
                }
               this.dialog = true;
                this.__getRoutes();
                this.__getVehicles();

            },
            hideModal() {
                this.dialog = false;

            },
            toggleModal() {
                this.$refs["my-modal"].toggle("#toggle-btn");
            }, __get(id) {
                routesVehicleService.show(id).then(response => {
                    this.routeVehicle = response.data.routesVehicles
                })
            },
            __getVehicles() {
                vehiclesService
                    .paginate(this.search)
                    .then(response => {
                        this.vehicles = response.data.data;
                        this.page = response.data.meta.current_page;
                        this.total = response.data.meta.total;
                        this.perPage = response.data.meta.per_page;
                    })
                    .catch(error => {
                        // console.log(error);
                    });
            },
            // generateFd() {
            //     // console.log(this.video)
            //     let fd = new FormData();
            //     for (let key in this.route) {
            //         if (key == "is_active" && this.video["is_active"]) {
            //             fd.append("is_active", this.video ? 1 : 0);
            //         } else {
            //             if (this.video[key] != null) {
            //                 fd.append(key, this.video[key]);
            //             }
            //         }
            //     }
            //     return fd;
            // },

            __getRoutes() {
                routesService
                    .paginate()
                    .then(response => {
                        this.routes = response.data.data;
                    })
                    .catch(error => {
                        // console.log(error);
                    });
            },
            createOrUpdate() {
                this.$v.routeVehicle.$touch();
                if (this.$v.routeVehicle.$error) {
                    setTimeout(() => {
                        this.$v.routeVehicle.$reset();
                    }, 3000);
                } else {
                    let fd = this.routeVehicle;
                    if (this.edit) {
                        this.updateAlbum(fd);
                    } else {
                        this.createAlbum(fd);
                    }
                }
            },
            updateAlbum(fd) {
                this.isBusy = true;
                routesVehicleService
                    .update(this.routeVehicle.id, fd)
                    .then(response => {
                        this.isBusy = false;
                        this.$snotify.success("Information updated");

                        this.resetForm();
                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$snotify.error("Something Went Wrong");
                        // console.log(error);
                    });
            },


            createAlbum(fd) {
                this.isBusy = true;
                routesVehicleService
                    .store(fd)
                    .then(response => {
                        this.isBusy = false;
                        this.resetForm();
                        this.$snotify.success("Information added");

                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$snotify.error("Something Went Wrong");
                        // console.log(error);
                    });
            },
            resetForm() {
                this.$v.routeVehicle.$reset();
                this.edit = false;
                this.route = {
                    title: null,
                    is_active: true
                };
                this.hideModal();
                this.$emit("refresh");
            }
        }
    };
</script>
